'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contractDoc = require('./contract.doc.document');

Object.defineProperty(exports, 'contract', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_contractDoc).default;
  }
});

var _exhibitCDoc = require('./exhibitC.doc.document');

Object.defineProperty(exports, 'exhibitC', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_exhibitCDoc).default;
  }
});

var _privacyDoc = require('./privacy.doc.document');

Object.defineProperty(exports, 'privacy', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_privacyDoc).default;
  }
});

var _receiptDoc = require('./receipt.doc.document');

Object.defineProperty(exports, 'receipt', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_receiptDoc).default;
  }
});

var _refundReceiptDoc = require('./refundReceipt.doc.document');

Object.defineProperty(exports, 'refundReceipt', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_refundReceiptDoc).default;
  }
});

var _singleContractDoc = require('./singleContract.doc.document');

Object.defineProperty(exports, 'singleContract', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_singleContractDoc).default;
  }
});

var _statementDoc = require('./statement.doc.document');

Object.defineProperty(exports, 'statement', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_statementDoc).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}